import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import { AuthProvider } from './features/auth';
import { Fehlergrenze, Toaster } from '@elbklar/ui';
import { captureException, initSentry } from './lib/sentry';
import './index.css';

// Initialize Sentry for error tracking (only in production)
initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Fehlergrenze onError={(error, info) => captureException(error, { componentStack: info.componentStack, errorBoundary: true })}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
            <Toaster />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Fehlergrenze>
  </React.StrictMode>
);
